<template>
  <div>
    <!-- 导航 -->
    <NavCustom></NavCustom>
    <div id="pdf">
      <pdf
        :src="src"
        :page="currentPage"
        @num-pages="pageCount = $event"
        @page-loaded="pagesLoad"
        @loaded="loadPdfHandler"
        @page-size="pageSize"
      ></pdf>
      <!-- 页码 上一页上一页按钮 -->
      <div class="plan-box" v-if="pageCount">
        <button @click="currentPage !== 1 ? changePdfPage(0) : ''">
          <img src="../assets/image/arr_left.png" />
        </button>
        <p class="pages">{{ currentPage }} / {{ pageCount }}</p>
        <button @click="currentPage !== pageCount ? changePdfPage(1) : ''">
          <img class="right" src="../assets/image/arr_left.png" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import pdf from "./vue-pdf/vuePdfNoSss.vue";
// import { Loading } from "element-ui";
import NavCustom from "@/components/nav-custom.vue";

export default {
  name: "vue-pdf",
  components: { pdf, NavCustom },
  data() {
    return {
      src: "",
      currentPage: 0, //当前页
      pageCount: 0, //总页数
      delayTime: 0,
      loadingInstance: null,
    };
  },
  watch: {
    pageCount(val) {
      if (val) {
        console.log(val, "pdf加载成功");
        // this.loadingInstance.close();
      }
    },
    // 利用watch方法检测路由变化：
    $route: function () {
      this.loadPdf();
    },
  },
  async mounted() {
    this.loadPdf();
  },
  methods: {
    loadPdf() {
      // this.loadingInstance = Loading.service({});
      const { url } = this.$route.query;
      let loadingTask = pdf.createLoadingTask(url);
      loadingTask.onProgress = (progressData) => {
        //获取文件大小  翻页时延迟  防止点击过快文件空白
        this.delayTime = progressData.total / 1000 / 4;
      };
      this.src = loadingTask;
    },
    // pdf渲染加载
    pagesLoad(e) {
      this.currentPage = e;
    },
    // pdf加载事件
    async loadPdfHandler() {
      this.currentPage = 1;
    },
    async pageSize(width, height, scale, originalWidth) {
      console.log(width, height, scale, originalWidth);
    },
    // pdf翻页
    async changePdfPage(val) {
      if (val === 0 && this.currentPage > 1) {
        this.currentPage--;
      }
      if (val === 1 && this.currentPage < this.pageCount) {
        this.currentPage++;
      }
      // await this.sleep(this.delayTime);
    },
  },
  beforeRouteLeave(_, __, next) {
    try {
      this.loadingInstance?.close();
    } catch (error) {
      console.log(error);
    }
    next();
  },
};
</script>

<style lang="scss" scoped>
#pdf {
  .plan-box {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    margin-top: 10px;
    button {
      width: 30px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      line-height: 30px;
      background-color: #dce0e9;
      border-radius: 2px;
      border: solid 1px #eeeeee;
      .icon {
        width: 13px;
        height: 12px;
      }
    }
    z-index: 1;
    .pages {
      width: 85px;
      height: 30px;
      margin: 0 20px;
      line-height: 30px;
      text-align: center;
      font-size: 13px;
      background-color: #dce0e9;
      border-radius: 2px;
      border: solid 1px #bcc9e7;
      color: #606266;
    }
  }
  .right {
    transform: rotate(180deg);
  }
}
</style>
